// Older preferences stored 'in_progress'; task.status is 'in progress'.
const LEGACY_TASK_STATUS = { in_progress: 'in progress' };

export default function normalizeTaskStatuses(statuses) {
  return (statuses || []).map((status) => LEGACY_TASK_STATUS[status] ?? status);
}
